angular.
module("dx.webapp.exams").
constant("DX_EXAMS_STEPS", Object.freeze({
	library: "library",
	scheduled: "scheduled",
	ongoing: "ongoing",
	ungraded: "ungraded",
	graded: "graded",
	published: "published",
}));
